export default __webpack_public_path__ + "static/media/icon-close-black.b326a1fe.svg";